import type { GeneratedRoute } from '@elegant-router/types';

export const constantRoutes: GeneratedRoute[] = [
  {
    name: '403',
    path: '/403',
    component: 'layout.blank$view.403',
    meta: {
      title: '403',
      i18nKey: 'route.403',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: '404',
    path: '/404',
    component: 'layout.blank$view.404',
    meta: {
      title: '404',
      i18nKey: 'route.404',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: '500',
    path: '/500',
    component: 'layout.blank$view.500',
    meta: {
      title: '500',
      i18nKey: 'route.500',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: 'iframe-page',
    path: '/iframe-page/:url',
    component: 'layout.base$view.iframe-page',
    props: true,
    meta: {
      title: 'iframe-page',
      i18nKey: 'route.iframe-page',
      constant: true,
      hideInMenu: true,
      multiTab: true,
      keepAlive: true
    }
  },
  {
    name: 'general-form',
    path: '/general-form/:config',
    component: 'layout.base$view.general-form',
    props: true,
    meta: {
      title: 'general-form',
      i18nKey: 'route.general-form',
      constant: true,
      hideInMenu: true,
      multiTab: true,
      keepAlive: true
    }
  },
  // {
  //   name: 'home',
  //   path: '/home',
  //   component: 'layout.base$view.home',
  //   meta: {
  //     title: 'home',
  //     i18nKey: 'route.home',
  //     icon: 'mdi:monitor-dashboard',
  //     order: 1
  //   }
  // },
  {
    name: 'login',
    path: '/login/:module(pwd-login)?',
    component: 'layout.blank$view.login',
    props: true,
    meta: {
      title: 'login',
      i18nKey: 'route.login',
      constant: true,
      hideInMenu: true
    }
  }
];
